export var MAUIMODES;
(function (MAUIMODES) {
    MAUIMODES["edit"] = "edit";
    MAUIMODES["clone"] = "clone";
    MAUIMODES["create"] = "create";
    MAUIMODES["add"] = "add";
})(MAUIMODES || (MAUIMODES = {}));
/**
 * Paths that correspond to draft pivots
 */
export var MAUIDraftEntityPaths;
(function (MAUIDraftEntityPaths) {
    MAUIDraftEntityPaths["metric"] = "metric";
    MAUIDraftEntityPaths["column"] = "column";
    MAUIDraftEntityPaths["segment"] = "segment";
    MAUIDraftEntityPaths["template"] = "template";
    MAUIDraftEntityPaths["enrichment"] = "enrichment";
    MAUIDraftEntityPaths["analysis"] = "analysis";
    MAUIDraftEntityPaths["scorecards"] = "scorecards";
    MAUIDraftEntityPaths["scorecard"] = "scorecard";
    MAUIDraftEntityPaths["preview"] = "preview";
    MAUIDraftEntityPaths["analysis-template"] = "analysis-template";
    MAUIDraftEntityPaths["configuration"] = "configuration";
    MAUIDraftEntityPaths["metric-health"] = "metric-health";
    MAUIDraftEntityPaths["publish-history"] = "publish-history";
    MAUIDraftEntityPaths["preview-scorecard"] = "preview-scorecard";
    MAUIDraftEntityPaths["metric-template"] = "metric-template";
})(MAUIDraftEntityPaths || (MAUIDraftEntityPaths = {}));
export var MAUIPivotNames;
(function (MAUIPivotNames) {
    MAUIPivotNames["CustomColumns"] = "Custom columns";
    MAUIPivotNames["Metrics"] = "Metrics";
    MAUIPivotNames["ComputationTemplates"] = "Computation templates";
    MAUIPivotNames["Segments"] = "Segments";
    MAUIPivotNames["ScorecarLayouts"] = "Scorecard layouts";
    MAUIPivotNames["Enrichments"] = "Enrichments";
    MAUIPivotNames["AnalysisTemplates"] = "Analysis templates";
    MAUIPivotNames["Configuration"] = "Configuration";
    MAUIPivotNames["MetricSetHealth"] = "Metric set health";
    MAUIPivotNames["PublishHistory"] = "Publish history";
    MAUIPivotNames["PreviewScorecard"] = "Preview scorecard";
})(MAUIPivotNames || (MAUIPivotNames = {}));
/**
 * All entity paths including configuration and setup
 */
export var MAUIEntityPaths;
(function (MAUIEntityPaths) {
    MAUIEntityPaths["metric"] = "metric";
    MAUIEntityPaths["column"] = "column";
    MAUIEntityPaths["segment"] = "segment";
    MAUIEntityPaths["template"] = "template";
    MAUIEntityPaths["enrichment"] = "enrichment";
    MAUIEntityPaths["analysis"] = "analysis";
    MAUIEntityPaths["scorecards"] = "scorecards";
    MAUIEntityPaths["scorecard"] = "scorecard";
    MAUIEntityPaths["preview"] = "preview";
    MAUIEntityPaths["analysis-template"] = "analysis-template";
    MAUIEntityPaths["configuration"] = "configuration";
    MAUIEntityPaths["setup"] = "setup";
    MAUIEntityPaths["metric-health"] = "metric-health";
    MAUIEntityPaths["publish-history"] = "publish-history";
    MAUIEntityPaths["preview-scorecard"] = "preview-scorecard";
})(MAUIEntityPaths || (MAUIEntityPaths = {}));
/**
 * Settings and configuration paths
 */
export var MAUIConfigurationPaths;
(function (MAUIConfigurationPaths) {
    MAUIConfigurationPaths["data-source"] = "data-source";
    MAUIConfigurationPaths["aggregation-level"] = "aggregation-level";
    MAUIConfigurationPaths["exp-setup"] = "exp-setup";
    MAUIConfigurationPaths["git-repo-setup"] = "git-repo-setup";
    MAUIConfigurationPaths["access-control-setup"] = "access-control-setup";
    MAUIConfigurationPaths["analysis-defaults"] = "analysis-defaults";
    MAUIConfigurationPaths["preview-scorecard-settings"] = "preview-scorecard-settings";
})(MAUIConfigurationPaths || (MAUIConfigurationPaths = {}));
/**
 * Enrichment paths
 */
export var MAUIEnrichmentPaths;
(function (MAUIEnrichmentPaths) {
    MAUIEnrichmentPaths["Alerts"] = "Alerts";
    MAUIEnrichmentPaths["SeedFinder"] = "SeedFinder";
    MAUIEnrichmentPaths["TrafficFilterDimensionMap"] = "TrafficFilterDimensionMap";
})(MAUIEnrichmentPaths || (MAUIEnrichmentPaths = {}));
/**
 * Settings and configuration paths
 */
export var MAUIMetricHealthPaths;
(function (MAUIMetricHealthPaths) {
    MAUIMetricHealthPaths["constant-value-metrics"] = "constant-value-metrics";
    MAUIMetricHealthPaths["inactive-metrics"] = "inactive-metrics";
    MAUIMetricHealthPaths["outlier"] = "outlier";
    MAUIMetricHealthPaths["sensitivity"] = "sensitivity";
    MAUIMetricHealthPaths["stat-sig"] = "stat-sig";
})(MAUIMetricHealthPaths || (MAUIMetricHealthPaths = {}));
export var MAUIPreviewScorecardPaths;
(function (MAUIPreviewScorecardPaths) {
    MAUIPreviewScorecardPaths["published-versions"] = "published-versions";
    MAUIPreviewScorecardPaths["recent-preview-analysis"] = "recent-preview-analysis";
})(MAUIPreviewScorecardPaths || (MAUIPreviewScorecardPaths = {}));
export var MAUIConfigurationNavPaneItems;
(function (MAUIConfigurationNavPaneItems) {
    MAUIConfigurationNavPaneItems["Datasource"] = "Datasource";
    MAUIConfigurationNavPaneItems["Aggregation level"] = "Aggregation level";
    MAUIConfigurationNavPaneItems["Experimentation configuration"] = "Experimentation configuration";
    MAUIConfigurationNavPaneItems["Git repository"] = "Git repository";
    MAUIConfigurationNavPaneItems["Access control"] = "Access control";
    MAUIConfigurationNavPaneItems["Analysis defaults"] = "Analysis defaults";
    MAUIConfigurationNavPaneItems["Preview scorecard settings"] = "Preview scorecard settings";
})(MAUIConfigurationNavPaneItems || (MAUIConfigurationNavPaneItems = {}));
export var MAUIMetricHealthNavPaneItems;
(function (MAUIMetricHealthNavPaneItems) {
    MAUIMetricHealthNavPaneItems["Constant value metrics"] = "Constant value metrics";
    MAUIMetricHealthNavPaneItems["Inactive metrics"] = "Inactive metrics";
    MAUIMetricHealthNavPaneItems["Outlier check"] = "Outlier check";
    MAUIMetricHealthNavPaneItems["Sensitivity check"] = "Sensitivity check";
    MAUIMetricHealthNavPaneItems["Stat-sig frequency check"] = "Stat-sig frequency check";
})(MAUIMetricHealthNavPaneItems || (MAUIMetricHealthNavPaneItems = {}));
export var MAUIPreviewScorecardNavPaneItems;
(function (MAUIPreviewScorecardNavPaneItems) {
    MAUIPreviewScorecardNavPaneItems["Published versions"] = "Published versions";
    MAUIPreviewScorecardNavPaneItems["Recent preview analysis"] = "Recent preview analysis";
})(MAUIPreviewScorecardNavPaneItems || (MAUIPreviewScorecardNavPaneItems = {}));

//# sourceMappingURL=MAUI.models.js.map
